import './index.scss';
import DrawSVG from 'react-svg-drawing'


const Logo = () => {

    return (
        <div className="logo-container">
            <DrawSVG 
                    strokeWidth='15px'
                    easing = 'easeInOutCubic' 
                    duration='8000'
                    width='100%'
                    loop={true} 
                    stroke='rgb(50, 72, 89)'  
                    SVGClass = 'logo-container'
            >
                <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
                width="484.000000pt" height="254.000000pt" viewBox="0 0 484.000000 254.000000"
                preserveAspectRatio="xMidYMid meet">
                    <g transform="translate(0.000000,254.000000) scale(0.100000,-0.100000)" fill="none" className='svg-container'>
                        <path d="M2261 2199 c-92 -25 -151 -58 -218 -122 -77 -74 -107 -147 -111 -270
                        -6 -153 6 -176 231 -462 75 -95 148 -149 277 -206 52 -23 121 -53 153 -66 68
                        -30 73 -50 23 -88 -150 -114 -465 -88 -640 54 -22 17 -44 30 -50 28 -7 -2 -12
                        -49 -14 -123 l-3 -119 143 -141 c144 -143 186 -172 292 -208 191 -65 434 -59
                        578 15 63 32 156 126 189 191 39 76 53 174 39 262 -18 116 -50 164 -227 337
                        -162 160 -204 191 -314 235 -35 13 -73 29 -84 34 -11 5 -42 18 -70 29 -27 10
                        -51 26 -53 34 -6 28 66 95 126 117 133 50 276 31 455 -60 54 -27 103 -50 108
                        -50 5 0 9 53 9 118 l0 118 -132 131 c-160 157 -206 183 -393 224 -73 15 -234
                        9 -314 -12z m366 -24 c35 -8 92 -28 128 -44 l65 -30 0 -96 c0 -53 -3 -95 -7
                        -93 -5 2 -35 17 -68 34 -188 98 -402 105 -526 15 -82 -58 -110 -150 -70 -229
                        35 -68 103 -109 301 -181 299 -109 410 -199 441 -360 9 -50 9 -77 0 -130 -43
                        -233 -256 -365 -561 -347 -157 9 -286 46 -370 106 -29 21 -30 23 -30 110 0 49
                        4 91 8 94 5 3 21 -4 38 -15 59 -41 169 -89 242 -105 113 -25 257 -16 340 21
                        151 68 194 211 93 308 -45 44 -123 83 -271 137 -235 86 -344 160 -397 268 -24
                        50 -28 69 -28 147 0 107 19 168 73 239 63 83 170 143 295 166 67 12 224 4 304
                        -15z"/>
                        <path d="M460 1456 l0 -744 132 -131 133 -131 105 2 105 3 5 280 5 280 80 3
                        80 2 95 -155 95 -155 174 -130 174 -130 133 0 c74 0 134 4 134 8 0 9 -36 69
                        -136 227 -39 61 -113 177 -164 259 l-94 149 23 16 c149 104 231 247 231 403 0
                        150 -46 233 -237 421 -261 258 -288 267 -769 267 l-304 0 0 -744z m720 700
                        c138 -45 246 -133 298 -243 24 -52 27 -69 27 -168 0 -105 -2 -114 -34 -180
                        -53 -108 -151 -199 -254 -236 -26 -9 -36 -18 -32 -28 3 -7 80 -132 170 -276
                        91 -145 168 -270 171 -279 5 -14 -7 -16 -104 -16 l-110 0 -138 228 c-76 125
                        -153 251 -171 280 l-34 53 -152 -3 -152 -3 -3 -278 -2 -277 -90 0 -90 0 0 726
                        0 726 323 -4 c273 -4 330 -7 377 -22z"/>
                        <path d="M665 1998 c-3 -7 -4 -135 -3 -283 l3 -270 210 1 c192 0 215 2 266 22
                        67 26 133 89 161 151 29 62 28 172 0 227 -27 54 -101 118 -160 140 -63 24
                        -469 34 -477 12z m635 -295 c0 -45 -44 -127 -86 -161 -55 -46 -132 -72 -210
                        -72 l-65 0 3 123 3 122 90 6 c50 3 129 6 178 7 l87 2 0 -27z"/>
                        <path d="M3340 1452 l0 -747 128 -128 127 -127 475 2 475 3 3 104 3 104 -133
                        133 -132 134 -228 0 -228 0 0 502 0 501 -132 134 -132 133 -113 0 -113 0 0
                        -748z m208 91 l2 -633 358 -2 357 -3 3 -87 3 -88 -456 0 -455 0 0 725 0 726
                        93 -3 92 -3 3 -632z"/>
                    </g>
                </svg>
            </DrawSVG>
        </div>
    )
};

export default Logo;